import React from 'react';
import {useTheme} from '@mui/styles';
import {Button, Collapse} from '@mui/material';
import {
  NotificationContainer,
  NotificationButtonContainer,
  HintText,
} from 'app/components/banner/NotificationHintStyles';

const SidebarBanner = ({primaryAction, secondaryAction, text, show}) => {
  const {palette} = useTheme();
  const PrimaryActionButton = primaryAction ? (
    <Button color='inherit' onClick={primaryAction.action}>
      {primaryAction.label}
    </Button>
  ) : null;

  const SecondaryActionButton = secondaryAction ? (
    <Button color='inherit' onClick={secondaryAction.action}>
      {secondaryAction.label}
    </Button>
  ) : null;

  const Actions =
    primaryAction || secondaryAction ? (
      <NotificationButtonContainer justify={secondaryAction ? 'space-between' : 'flex-end'}>
        {SecondaryActionButton}
        {PrimaryActionButton}
      </NotificationButtonContainer>
    ) : null;

  return (
    <Collapse in={show}>
      <NotificationContainer color={palette.warning.light}>
        <HintText variant='body1'>{text}</HintText>
        {Actions}
      </NotificationContainer>
    </Collapse>
  );
};

export {SidebarBanner};
